<template>
  <span
    class="
      tw-inline-flex
      tw-items-center
      tw-gap-1
      tw-h-5
      tw-px-1.5
      tw-rounded-full
      tw-border
      tw-border-solid
      tw-shadow-sm
      tw-text-xs
      tw-leading-4
      tw-font-medium
    "
    :class="variantClass"
    data-testid="sf-static-pill"
  >
    <slot />
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { StaticPillVariant } from './constants'
import { staticPillVariants } from './constants'

defineOptions({ name: 'SfStaticPill' })

interface Props {
  variant?: StaticPillVariant
}

const props = withDefaults(defineProps<Props>(), {
  variant: staticPillVariants.NEUTRAL,
})

const variantClasses: Record<StaticPillVariant, string> = {
  [staticPillVariants.NEUTRAL]:
    'tw-bg-sf-slate-subtle-1 tw-text-sf-slate-dark-1 tw-border-sf-slate-light-1/30',
  [staticPillVariants.SUCCESS]:
    'tw-bg-sf-success-subtle-1 tw-text-sf-success-dark-1 tw-border-sf-success-dark-1/20',
  [staticPillVariants.WARNING]:
    'tw-bg-sf-warning-subtle-1 tw-text-sf-warning-dark-1 tw-border-sf-warning-dark-1/20',
  [staticPillVariants.DANGER]:
    'tw-bg-sf-danger-subtle-1 tw-text-sf-danger-dark-1 tw-border-sf-danger-dark-1/20',
  [staticPillVariants.INFO]:
    'tw-bg-sf-info-subtle-1 tw-text-sf-info-dark-1 tw-border-sf-info-dark-1/20',
  [staticPillVariants.AI]:
    'tw-bg-sf-ai-subtle-1 tw-text-sf-ai-dark-1 tw-border-sf-ai-dark-1/20',
}

const variantClass = computed(() => variantClasses[props.variant])
</script>
